import { Store, Action, AnyAction, Middleware, MiddlewareAPI } from 'redux';
import { Dispatch } from 'react-redux';

export interface IFetchAction extends Action {
    fetch: Request,
    meta?: any,
    contentType?: string,
}

export interface IAsyncAction extends Action {
    meta?: any,
}

export interface FetchPendingAction {
    type: string,
    fetch: Promise<void>
}

export enum FetchStatus {
    Pending = '/pending',
    Complete = '/complete',
    Failed = '/failed'
}

export const fetchMiddleware: any = ({ dispatch }: MiddlewareAPI<any>) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {

    // Check if this is a fetch action
    if (!action.fetch) {
        return next(action);
    }

    if (!action.contentType || action.contentType !== 'formData') {
        // Set default JSON header
        action.fetch.headers.set('Content-Type', 'application/json; charset=utf-8')
    }

    // Create the request
    const request = fetch(action.fetch, { credentials: 'include', cache: 'no-cache' })
        // Get data on ok, reject on not ok
        .then(res => res.ok

            // Only look at json on 200
            ? (res.status === 200 ? res.json() : null)
            : Promise.reject(res)

        // Dispatch the complete action with data on success
        ).then(data => {
            dispatch({
                type: action.type + FetchStatus.Complete,
                data,
                meta: action.meta
            });
        // Dispatch error on failure
        }).catch(err => {
            // if the error was that it was unauthorized we want to redirect the user to the login page
            if (err.status === 401) {
                window.location.replace((window as any).loginInfo.loginUrl + '?returnUrl=' + window.location.href);
            }

            err.json().then(function (value) {
                dispatch({
                    type: action.type + FetchStatus.Failed,
                    err: value,
                    meta: action.meta
                });
            })

            throw Error(err)
        })

    // Continue to next middleware
    return next({
        type: action.type + FetchStatus.Pending,
        fetch: request,
        meta: action.meta
    })
}